import { render, staticRenderFns } from "./Exam_bridge.vue?vue&type=template&id=46ed6e92&scoped=true"
import script from "./Exam_bridge.vue?vue&type=script&lang=js"
export * from "./Exam_bridge.vue?vue&type=script&lang=js"
import style0 from "./Exam_bridge.vue?vue&type=style&index=0&id=46ed6e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed6e92",
  null
  
)

export default component.exports